import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMicrophone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMicrophone"><Path d="M11.9999 19.5C15.4494 19.5 18.3551 17.1712 19.2303 14M11.9999 19.5C8.55038 19.5 5.64478 17.1712 4.76953 14M11.9999 19.5V21.5M11.9999 16.5C9.51463 16.5 7.49992 14.4853 7.49992 12V7C7.49992 4.51472 9.51463 2.5 11.9999 2.5C14.4852 2.5 16.4999 4.51472 16.4999 7V12C16.4999 14.4853 14.4852 16.5 11.9999 16.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMicrophone;
